<template>
	<App title="Wallets">
		<div class="row">
			<div class="col">
				<Block>
					<template #header>
						<h3 class="block-title">Wallets</h3>
					</template>
					<Datatable :options="options" />
				</Block>
			</div>
		</div>
	</App>
</template>

<script lang="ts">
import Block from '@/vue/components/Block.vue'
import Datatable from '@/vue/components/Datatable.vue'
import App from '@/vue/templates/App.vue'
import { CellRender, Column } from '@/vue/utils/Datatable'
import { Config } from 'datatables.net-bs5'
import { Component, Vue, toNative } from 'vue-facing-decorator'

@Component({
	components: {
		App,
		Block,
		Datatable,
	},
})
class Group extends Vue {
	get buttons() {
		let buttons: any[] = []
		buttons.push('refresh')
		buttons.push('trashed')

		return buttons
	}

	get columns() {
		let columns: any[] = []
		columns.push({
			data: 'id',
			orderable: true,
			name: 'id',
			title: 'Id',
		})

		columns.push({
			data: 'agent.fullname',
			title: 'User',
			orderable: true,
		})
		columns.push({
			data: 'bank',
			title: 'Bank',
		})

		columns.push({
			data: 'number',
			title: 'Number',
			class: 'text-start',
		})

		columns.push({
			data: 'balance',
			title: 'Balance',
			render: CellRender.money(),
			class: 'text-start',
		})

		columns.push({
			data: 'created_at',
			title: 'Opened',
			name: 'created_at',
			render: CellRender.date(),
			orderable: true,
		})

		columns.push(Column.actions(this.$gate, { update: false, view: false }))

		return columns
	}

	get options(): Config {
		return {
			ajax: {
				url: this.route('wallet.ajax.table'),
				method: 'POST',
			},
			buttons: this.buttons,
			columns: this.columns,
			order: [[5, 'desc']],
		}
	}
}

export default toNative(Group)
</script>
